import { DayOffOptionsType } from './types';

export const DAY_OFF_OPTIONS: DayOffOptionsType = [
  { id: 'netflix_chill', title: '🎬 Netflix & chill' },
  { id: 'outdoor_hiking', title: '🧭 Outdoor hiking' },
  { id: 'party_clubbing', title: '🪩 Party / clubbing' },
  { id: 'brunch_friends', title: '🍻 Brunch with friends' },
  { id: 'reading_writing', title: '📖 Reading / writing' },
];
